import { useState, useEffect } from "react";
import { SERVICES } from "../services";
import React from "react";
import {
  utils,
  Notifications,
  Accordion,
  BasicRow,
  TextCell,
  Table,
  RawCell,
  CellHeader,
  ActionButton,
  ActionButtonsCell,
} from "@truenorthmortgage/olympus";
import Loading from "../components/Loading";
import NavComponent from "../components/NavComponent";
import NotificationComponent from "../components/NotificationComponent";
import { PhoneLink } from "../components";
import BreadcrumbsComponent from "../components/BreadcrumbsComponent";
import KratosModal from "../components/Modals/KratosModal";
import PurchaseModal from "../components/Modals/ActionQueue/PurchaseModal";
import { useParams, useSearchParams } from "react-router-dom";
import { InvestorStatementService } from "../services/investor-statement-service";
import { notify, downloadPdf } from "../utils";
import { ERROR } from "../constants";
import { InvestmentAccountService } from "../services/investment-account-service";

const MonthlyInvestorReports = () => {
  const [isLoading, setIsLoading] = useState(true);

  const investmentAccountService =
    utils.injection.useInjection<InvestmentAccountService>(
      SERVICES.InvestmentAccountService
    );

  const investorStatementService =
    utils.injection.useInjection<InvestorStatementService>(
      SERVICES.InvestorStatementService
    );

  const { investment_account_uuid } = useParams();

  const breadcrumbs = [
    { label: "Dashboard", path: "/dashboard" },
    {
      label: "Annual Investor Reports",
      path: "/annual-investor-reports/",
    },
  ];

  const [activationDate, setActivationDate] = useState<any>();
  const [currentDate] = useState(new Date().getFullYear());
  const [investmentAccountFriendlyID, setInvestmentAccountFriendlyID] =
    useState("");

  useEffect(() => {
    const submitValues = {
      uuid: investment_account_uuid ?? null,
    };
    investmentAccountService
      .getInvestmentAccountData({ InvestmentAccountForm: submitValues })
      .then((data) => {
        setInvestmentAccountFriendlyID(data?.investment_account?.friendly_id);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [investment_account_uuid]);

  // TODO: We need to get the account and activation date from the investment account information since we are grabbing the investment account not the investor account we have to grab it another way
  useEffect(() => {
    const submitValues = {
      uuid: investment_account_uuid ?? null,
    };
    investorStatementService
      .getActivationDate({ InvestorAccountForm: submitValues })
      .then((data) => {
        setInvestmentAccountFriendlyID(data?.investor_account_friendly_id);
        setActivationDate(data?.investor_activation_date);
        setIsLoading(false);
      })
      .catch((error) => {
        notify(error?.message ?? ERROR.INTERNAL_SERVER_ERROR.label, "error");
        setIsLoading(false);
      });
  }, [investment_account_uuid]);

  // Store Entire BreadCrumb
  localStorage.setItem("breadcrumbs", JSON.stringify(breadcrumbs));

  // Open the Investment Purchase Modal!
  const [isActionQueuePurchaseOpen, setIsActionQueuePurchaseOpen] =
    useState(false);

  const closeActionQueuePurchase = () => {
    setIsActionQueuePurchaseOpen(false);
  };

  const [investmentListingObject, setInvestmentListingObject] = useState({});
  const subjects = [
    "<strong>First subject</strong>",
    "<strong>Second subject</strong>",
  ];

  useEffect(() => {}, [activationDate]);

  const downloadMonthlyReport = (
    month: any,
    year: any,
    investmentAccountFriendlyID: any
  ) => {
    setIsLoading(true);
    // Make API request to kratos to download the monthly statement
    const submitValues = {
      investment_account_uuid: investment_account_uuid ?? null,
      month: month ?? null,
      year: year ?? null,
    };
    investorStatementService
      .downloadMonthlyReport({ monthlyReportData: submitValues })
      .then((data) => {
        downloadPdf(
          data?.report_data,
          year,
          month,
          investmentAccountFriendlyID,
          "monthly"
        );
        setIsLoading(false);
      })
      .catch((error) => {
        notify(error?.message ?? ERROR.INTERNAL_SERVER_ERROR.label, "error");
        setIsLoading(false);
      });
  };

  // DynamicAccordions Component
  const DynamicAccordions = () => {
    if (!activationDate) return null;

    const startDate = new Date(activationDate);
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
    const activationYear = startDate.getFullYear();
    const activationMonth = startDate.getMonth();
    const accordions = [];
    const currentMonth = currentDate.getMonth();

    // Loop through the years and generate the accordions
    for (let year = currentYear; year >= activationDate; year--) {
      // Skip the current year only generate previous years !
      if (year === 2024) continue;
      if (year === currentYear) continue;

      const months = [];
      const startMonth = year === activationYear ? activationMonth : 0;
      const endMonth = year === currentYear ? currentMonth : 11;

      for (let month = startMonth; month <= endMonth; month++) {
        const date = new Date(year, month, 1);
        const label = `${date.toLocaleString("default", {
          month: "long",
        })} ${year}`;
        const shortMonth = date.toLocaleString("default", { month: "short" });
        const fullMonth = date.toLocaleString("default", { month: "long" });
        const fullyear = date.getFullYear();
        const numbered_month = date.getMonth() + 1;

        months.push(
          <BasicRow key={year} rowClasses={["white-row"]}>
            <RawCell className="black-bold">{`${shortMonth}, ${fullyear}`}</RawCell>
            <RawCell className="black-bold">
              {`Monthly statement Personal Investor Account ${investmentAccountFriendlyID}`}
            </RawCell>
            <RawCell className="black-bold">
              <ActionButton
                className=""
                id={`download-annual-report-${year}`}
                key={`download-annual-report-${year}`}
                callback={() =>
                  downloadMonthlyReport(
                    numbered_month,
                    year,
                    investmentAccountFriendlyID
                  )
                }
              >
                <i
                  style={{ marginRight: "5px" }}
                  className="fa-solid fa-file-invoice"
                ></i>
              </ActionButton>
            </RawCell>
          </BasicRow>
        );
      }

      accordions.push(
        <Accordion
          key={year}
          heading=""
          subjects={[`${year} Monthly Statements`]}
          title=""
          itemsSize="two"
        >
          {/*TODO: Loop through each month for each year to generate the report links */}
          <Table className="primary overview-table table-no-display-block monthly-report-inner-table">
            <CellHeader className="table-header">
              <RawCell className="black-bold">Name</RawCell>
              <RawCell className="black-bold">Date</RawCell>
              <RawCell className="black-bold">Download</RawCell>
            </CellHeader>
            {months}
          </Table>
        </Accordion>
      );
    }

    return accordions.length > 0 ? (
      <div className="monthly-report-wrapper">{accordions}</div>
    ) : (
      <div className="monthly-report-wrapper">No monthly reports available</div>
    );
  };

  return isLoading ? (
    <Loading />
  ) : (
    <>
      <KratosModal
        is_open={isActionQueuePurchaseOpen}
        callback={closeActionQueuePurchase}
      >
        <PurchaseModal
          callback={closeActionQueuePurchase}
          investment_listing_object={investmentListingObject}
        />
      </KratosModal>

      <div className="dashboard-container">
        <NavComponent />
      </div>
      <div id="main" className="dashboard-content">
        <Notifications
          timeout={15000}
          customNotificationElement={<NotificationComponent />}
        />
        <div className="main-header">
          <BreadcrumbsComponent items={breadcrumbs} />
        </div>
        <div className="main-content">
          <div className="dashboard investment-listings-container">
            <h1
              style={{ textTransform: "capitalize", marginBottom: "3px" }}
              className={"mobile-header"}
            >
              Personal Investor {investmentAccountFriendlyID}
            </h1>

            <div className={"annual-report-wrapper"}>
              <h2>{currentDate} Monthly Statements </h2>

              <div className="divider" />
              <Table className="primary annual-report-table overview-table table-no-display-block">
                <CellHeader className="table-header">
                  <RawCell className="black-bold">Name</RawCell>
                  <RawCell className="black-bold">Description</RawCell>
                  <RawCell className="black-bold">Download</RawCell>
                </CellHeader>
                {Array.from({ length: new Date().getMonth() + 1 }, (_, i) => {
                  const monthIndex = new Date().getMonth() - i; // current month first
                  const date = new Date(
                    new Date().getFullYear(),
                    monthIndex,
                    1
                  );
                  const monthYear = `${date.toLocaleString("default", {
                    month: "short",
                  })}, ${date.getFullYear()}`;
                  const year = date.getFullYear(); // Gets the year as a number (e.g., 2025)
                  const month = date.getMonth() + 1;

                  return (
                    <BasicRow key={monthYear} rowClasses={["white-row"]}>
                      <RawCell className="black-bold">{`${monthYear}`}</RawCell>
                      <RawCell className="black-bold">
                        {`${monthYear} Monthly Statement Personal Investment Account ${investmentAccountFriendlyID}`}
                      </RawCell>
                      <RawCell className="black-bold">
                        <ActionButton
                          className=""
                          id={`download-annual-report-${monthYear}`}
                          key={`download-annual-report-${monthYear}`}
                          callback={() =>
                            downloadMonthlyReport(
                              month,
                              year,
                              investmentAccountFriendlyID
                            )
                          }
                        >
                          <i
                            style={{ marginRight: "5px" }}
                            className="fa-solid fa-file-invoice"
                          ></i>
                        </ActionButton>
                      </RawCell>
                    </BasicRow>
                  );
                })}
              </Table>

              <h2>Previous Monthly Statements</h2>

              {/* Render Dynamic Accordions here */}
              <DynamicAccordions />
            </div>
            <div className="footer-content"></div>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer__phone-link">
          Need help?
          <PhoneLink />
        </div>
      </div>
    </>
  );
};

export default MonthlyInvestorReports;
